$(document).ready(function() {
  //  collection Slider
  $('.bnrsec.banner-slider').slick({
    dots: true,
    infinite: true,
    speed: 300,
    arrows:false,
    slidesToShow:1,
    slidesToScroll: 1,
    autoplay:true,
  });
  // Review Slider
  $('.reviewsec .row').slick({
  dots: false,
  infinite: true,
  speed: 300,
  arrows:false,
  slidesToShow:3,
  slidesToScroll: 1,
  autoplay:true,
  responsive: [
  {
    breakpoint: 1024,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 1
    }
  },
  {
    breakpoint: 767,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1
    }
  }]
});
});